<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
const [name] = createNamespace('SelfBuildTownResettleStandardDisplay')

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    return () => (
      <div class='ant-row-form-item'>
        政策补助。按
        <b>{props.data.tongGuiZiJianAnZhiXiangZhen} 元/人</b>
        （包括搬迁奖励、建房补助及过渡费）标准执行。
      </div>
    )
  }
})
</script>
